export var RED_PINK = '#ff373c';
export var RED = '#ec0000';
export var ORANGE = '#ff8228';
export var LIGHT_ORANGE = '#ffb432';
export var LIGHT_BLUE = '#d2f0ff';
export var GREY = '#505050';
export var LIGHT_GREY = '#535353';
export var BLUE = '#3f75c6';
export var GREEN = '#008906';
export var LIGHT_GREEN = '#a5bb48';
export var PURPLE = '#c34789';
export var GREY4 = '#f8f8f8';
export var GREY8 = '#f1f1f1';
export var GREY16 = '#e3e3e3';
export var GREY24 = '#d5d5d5';
export var GREY48 = '#ababab';
export var GREY80 = '#737373';
export var GREY56 = '#232323';
export var WHITE = 'white';
export var BLACK = 'black';
export var TRANSPARENT = 'transparent';